import {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { errorsActions, markersActions } from '../store';
import { usePrevious } from '../reactHelper';
import { fetchMarkers } from '../common/util/deviceData';

// Keeps the marker index in the store for the query the map is showing:
// fetched when the query changes and again after the socket reconnects,
// since nothing is replayed on reconnect. Returns whether the index for the
// current query has landed.
export default (query) => {
  const dispatch = useDispatch();
  const socket = useSelector((state) => state.session.socket);
  const previousSocket = usePrevious(socket);

  const [loaded, setLoaded] = useState(false);
  const generation = useRef(0);

  const reload = useCallback(async () => {
    generation.current += 1;
    const started = generation.current;
    try {
      const markers = await fetchMarkers(query);
      if (started === generation.current) {
        dispatch(markersActions.refresh({ markers, filtered: !!query }));
        setLoaded(true);
      }
    } catch (error) {
      dispatch(errorsActions.push(error.message));
    }
  }, [query, dispatch]);

  useEffect(() => {
    setLoaded(false);
    reload();
  }, [query]);

  useEffect(() => {
    if (socket && previousSocket === false) {
      reload();
    }
  }, [socket]);

  return loaded;
};
